export default {
    title: '수업 구성',
    nextLesson: {
        default: '다음 수업 진도',
        see: '다음 수업 진도 보기',
    },
    mainUnit: {
        recently: '최근에 진행한 대단원',
    },
    middleUnit: {
        recently: '최근에 진행한 중단원',
    },
    small_unit: {},
    lessonBlock: {
        noActivity: '연결된 활동꾸러미가 없습니다.',
    },
    emptyContent: '수업 콘텐츠 준비중입니다. 조금만 기다려 주세요!',
    upcomingContent: '더 많은 콘텐츠가 공개될 예정입니다. 조금만 기다려 주세요!',
    buttons: {
        start: '자습 시작',
        startLecture: '수업 시작',
    },
    preview: '활동 미리보기',
};
